export default __webpack_public_path__ + "static/media/icon_logout_dashboard.236a3dc0.svg";